import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { eventCashFlowInitialValues, IEventCashFlowForm } from 'components/organisms/forms/event-cash-flow/EventCashFlowForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import { eventCashFlowFormToQuery } from 'middleware/event-cash-flow/eventCashFlowFormToQuery';
import { useTranslation } from 'react-i18next';
import { PiHandCoinsBold, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateEventIncome } from 'services/events/income';
import { ICreateEventIncome } from 'services/events/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CreateEventIncome = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const eventId = useParamId('event');
  const createEventIncome = useCreateEventIncome();

  const mutateOptions = useMutateOptions<IEventCashFlowForm>();

  const onCreateEventIncome = async (
    values: IEventCashFlowForm,
    helpers: FormikHelpers<IEventCashFlowForm>
  ) => {
    const eventIncomeData = eventCashFlowFormToQuery(values, 'income') as ICreateEventIncome;
    
    await createEventIncome.mutateAsync(eventIncomeData, {
      ...mutateOptions(helpers),
      onSuccess: () => navigate(`/event/${eventId}/balance`),
    });
  };

  return (
    <Form.EventCashFlow
      i18nextPrefix='event-income'
      initialValues={{
        ...eventCashFlowInitialValues,
        eventId: eventId,
      }}
      onSubmit={onCreateEventIncome}
      customBackItem={
        <Button type='button' onlyIcon onClick={() => navigate(`/event/${eventId}/balance`)}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
          <Button.Icon icon={<PiHandCoinsBold />} />
        </Button>
      }
    />
  );
};

export default CreateEventIncome; 